import { AdRequestParameterValidationResult } from './ad-request-parameter-validation-result.model';
import { ApiBind, Common } from './common.model';

/**
 * 広告リクエストの登録/更新でレスポンスの情報.
 *
 * @exports
 * #@extends Common
 */
export class AdRequestPostResponse extends Common {
  @ApiBind({ column: 'required' })
  required: string;

  @ApiBind({
    column: 'validations',
    model: (values) => values.map((v) => new AdRequestParameterValidationResult(v)),
  })
  validations: AdRequestParameterValidationResult[];
}
